import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin, message, Typography } from "antd";
import axios from "axios";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";

const { Title } = Typography;

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchBlog = async () => {
    setLoading(true);
    try {
      const authToken = localStorage.getItem("token") || "";

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Blog/${slug}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setBlog(response.data?.data || response.data);
    } catch (error) {
      console.error(error);
      message.error("Failed to load blog");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slug) fetchBlog();
  }, [slug]);

  return (
    <>
      <HeaderLayout />
      <div style={{ padding: 24, minHeight: "70vh", maxWidth: 900, margin: "auto" }}>
        {loading ? (
          <div style={{ textAlign: "center", marginTop: 80 }}>
            <Spin size="large" />
          </div>
        ) : blog ? (
          <>
            <br/>
            <Title>{blog.title}</Title>
             <br/>
            <img
              src={blog.coverImageUrl}
              alt={blog.title}
              style={{
                width: "100%",
                borderRadius: 12,
                marginBottom: 24,
              }}
            />

          

            {/* Full HTML Content */}
            <div
              dangerouslySetInnerHTML={{ __html: blog.content }}
              style={{
                marginTop: 24,
                lineHeight: 1.8,
                fontSize: 16,
              }}
            />
          </>
        ) : null}
      </div>
      <FooterLayout />
    </>
  );
};

export default BlogDetail;